import { action } from 'typesafe-actions';

import { DeliveryDiscountTypes, IDeliveryDiscountData } from './types';

export const loadRequest = () => action(DeliveryDiscountTypes.LOAD_REQUEST);
export const loadSuccess = (data: IDeliveryDiscountData[]) =>
  action(DeliveryDiscountTypes.LOAD_SUCCESS, data);
export const loadFailure = () => action(DeliveryDiscountTypes.LOAD_FAILURE);
